import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { UpgradeAvailabilityModel } from './upgrade-availability.state';

/** StateDetailsActions */
const ACTION_SET = '[UpgradeAvailability] set';
const ACTION_UPDATE = '[UpgradeAvailability] update';
const ACTION_RESET = '[UpgradeAvailability] reset';
const ACTION_FAIL = '[UpgradeAvailability] fail';
const ACTION_CANCEL_REQUEST = '[UpgradeAvailability] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[UpgradeAvailability] set from api';
const ACTION_UPDATE_FROM_API = '[UpgradeAvailability] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setUpgradeAvailability = createAction(ACTION_SET, props<WithRequestId<UpgradeAvailabilityModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateUpgradeAvailability = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<UpgradeAvailabilityModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetUpgradeAvailability = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelUpgradeAvailabilityRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failUpgradeAvailability = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setUpgradeAvailabilityFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<UpgradeAvailabilityModel>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateUpgradeAvailabilityFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<UpgradeAvailabilityModel>>()
);
